// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../types';

import gql from 'graphql-tag';
import { SideBarEventFragmentDoc } from './SideBar/SideBar.generated-types';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type EventHubEventsQueryVariables = Types.Exact<{
  active: Types.EventActiveArg;
  sort?: Types.InputMaybe<Types.EventSortArg>;
}>;


export type EventHubEventsQuery = { __typename?: 'Query', getEventsByUser: Array<{ __typename?: 'Event', UUID: string, name: string, location: string, status: Types.EventStatus, fromDateTime: string, toDateTime: string, proposalCount: number, proposals: Array<{ __typename?: 'Proposal', UUID: string, invitationID: number, status: Types.ProposalStatus }>, invitations?: Array<{ __typename?: 'Invitation', ID: number, declinedAt?: string | null }> | null }> };

export type EventHubEventFragment = { __typename?: 'Event', UUID: string, name: string, location: string, status: Types.EventStatus, fromDateTime: string, toDateTime: string, proposalCount: number, proposals: Array<{ __typename?: 'Proposal', UUID: string, invitationID: number, status: Types.ProposalStatus }>, invitations?: Array<{ __typename?: 'Invitation', ID: number, declinedAt?: string | null }> | null };

export const EventHubEventFragmentDoc = gql`
    fragment EventHubEvent on Event {
  ...SideBarEvent
}
    ${SideBarEventFragmentDoc}`;
export const EventHubEventsDocument = gql`
    query EventHubEvents($active: EventActiveArg!, $sort: EventSortArg) {
  getEventsByUser(active: $active, sort: $sort) {
    ...EventHubEvent
  }
}
    ${EventHubEventFragmentDoc}`;

export function useEventHubEventsQuery(options: Omit<Urql.UseQueryArgs<EventHubEventsQueryVariables>, 'query'>) {
  return Urql.useQuery<EventHubEventsQuery>({ query: EventHubEventsDocument, ...options });
};